var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 4.5,
    cy: 4.5,
    r: 3.75,
    stroke: "black",
    strokeOpacity: 0.55,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M9.06066 8.5L11.5355 10.9749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    stroke: "black",
    strokeOpacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSmall);
export default __webpack_public_path__ + "static/media/search-small.eef0403cbb473bac52c46644d9fa965a.svg";
export { ForwardRef as ReactComponent };